import React from "react";

interface Assessment {
    id: string;
    date: string;
    time: string;
    painLevel: string;
    nonPharmacologicalIntervention: string;
    syariahIntervention: string;
    tanggalKajiUlang: string;
}

interface AssessmentHistoryProps {
    assessments: Assessment[];
}

const AssessmentHistory: React.FC<AssessmentHistoryProps> = ({ assessments }) => {
    return (
        <div className="overflow-x-auto">
            {assessments.length > 0 ? (
                <table className="min-w-full border-collapse border border-gray-300">
                    <thead>
                    <tr className="bg-gray-100 text-center">
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Tanggal</th>
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Jam</th>
                        <th colSpan={3} className="border border-gray-300 px-4 py-2">Nyeri</th>
                        <th colSpan={3} className="border border-gray-300 px-4 py-2">Intervensi Farmakologi</th>
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Intervensi Non Farmakologi</th>
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Intervensi Syariah</th>
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Perawat/Bidan</th>
                        <th rowSpan={2} className="border border-gray-300 px-4 py-2">Waktu Kaji Ulang</th>
                    </tr>
                    <tr className="bg-gray-100 text-center">
                        <th className="border border-gray-300 px-4 py-2">Ya</th>
                        <th className="border border-gray-300 px-4 py-2">Tidak</th>
                        <th className="border border-gray-300 px-4 py-2">Skala</th>
                        <th className="border border-gray-300 px-4 py-2">Ya</th>
                        <th className="border border-gray-300 px-4 py-2">Tidak</th>
                        <th className="border border-gray-300 px-4 py-2">Jam Tindakan</th>
                    </tr>
                    </thead>
                    <tbody>
                    {assessments.map((assessment) => (
                        <tr key={assessment.id} className="text-center">
                            <td className="border border-gray-300 px-4 py-2">{assessment.date}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.time}</td>
                            <td className="border border-gray-300 px-4 py-2">√</td>
                            <td className="border border-gray-300 px-4 py-2"></td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.painLevel}</td>
                            <td className="border border-gray-300 px-4 py-2">√</td>
                            <td className="border border-gray-300 px-4 py-2"></td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.time}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.nonPharmacologicalIntervention}</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.syariahIntervention}</td>
                            <td className="border border-gray-300 px-4 py-2">Andy</td>
                            <td className="border border-gray-300 px-4 py-2">{assessment.tanggalKajiUlang}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            ) : (
                <p>No assessments recorded.</p>
            )}
        </div>
    );
};

export default AssessmentHistory;
